// Mock data per SI.SA. LINE S.r.l.

export const companyInfo = {
  name: "SI.SA. LINE S.r.l.",
  tagline: "Segnaletica Stradale",
  description: "Specialisti in segnaletica stradale e generale. Offriamo un servizio completo dalla consulenza alla manutenzione.",
  phone: "+39 393 9923354",
  email: "info@sisaline.it",
  address: "Italia"
};

export const team = [
  {
    id: 1,
    name: "Andrea Molinaro",
    role: "Direttore Generale",
    phone: "+39 393 9923354",
    email: "andrea.molinaro@sisasegnaleticasrl.eu",
    image: "https://customer-assets.emergentagent.com/job_1339b4ee-79eb-48d1-9f64-307ac7401951/artifacts/shomcg6m_Logo3.jpg"
  },
  {
    id: 2,
    name: "Gaetano Salomone",
    role: "Direttore Tecnico",
    phone: "+39 320 3870877",
    email: "gaetano.salomone@sisasegnaleticasrl.eu",
    image: "https://customer-assets.emergentagent.com/job_1339b4ee-79eb-48d1-9f64-307ac7401951/artifacts/shomcg6m_Logo3.jpg"
  },
  {
    id: 3,
    name: "Alessandro Ugoletti",
    role: "Direttore Commerciale",
    phone: "+39 338 8152266",
    email: "a.ugoletti@sisasegnaleticasrl.eu",
    image: "https://customer-assets.emergentagent.com/job_1339b4ee-79eb-48d1-9f64-307ac7401951/artifacts/shomcg6m_Logo3.jpg"
  }
];

export const services = [
  {
    id: 1,
    title: "Segnaletica Orizzontale",
    description: "Realizzazione di segnaletica orizzontale interna ed esterna per aree logistiche, parcheggi, centri commerciali e impianti industriali.",
    features: ["Materiali certificati", "Tecnologie avanzate", "Conformità normativa", "Durabilità garantita"]
  },
  {
    id: 2,
    title: "Segnaletica Verticale",
    description: "Installazione di cartelli, pannelli informativi e segnaletica verticale personalizzata per spazi pubblici e privati.",
    features: ["Design personalizzato", "Installazione professionale", "Materiali resistenti", "Manutenzione inclusa"]
  },
  {
    id: 3,
    title: "Cartellonistica Personalizzata",
    description: "Progettazione e realizzazione di cartellonistica su misura per le esigenze specifiche del cliente.",
    features: ["Progetti su misura", "Grafica professionale", "Produzione interna", "Consegna rapida"]
  },
  {
    id: 4,
    title: "Trattamenti con Resine",
    description: "Applicazione di resine e vernici professionali per pavimenti industriali e aree ad alto traffico.",
    features: ["Resine certificate", "Resistenza chimica", "Facile manutenzione", "Finitura professionale"]
  },
  {
    id: 5,
    title: "Installazione Strutture",
    description: "Installazione di portali, totem e strutture per segnaletica di grande formato.",
    features: ["Strutture robuste", "Installazione sicura", "Progettazione tecnica", "Sopralluogo gratuito"]
  },
  {
    id: 6,
    title: "Tinteggiature",
    description: "Servizi di tinteggiatura interna ed esterna per capannoni industriali, uffici e strutture commerciali.",
    features: ["Vernici professionali", "Team qualificato", "Lavoro rapido", "Risultato impeccabile"]
  },
  {
    id: 7,
    title: "Accessori di Sicurezza",
    description: "Fornitura e posa di accessori di sicurezza: rallentatori, panettoni in CLS, manufatti e altri dispositivi per la sicurezza stradale.",
    features: ["Rallentatori certificati", "Panettoni in CLS", "Manufatti su misura", "Installazione professionale"]
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Analisi",
    description: "Comprendiamo le esigenze specifiche del cliente e analizziamo il contesto operativo."
  },
  {
    id: 2,
    step: "02",
    title: "Sopralluogo",
    description: "Effettuiamo un'ispezione accurata del sito per valutare le condizioni e le necessità tecniche."
  },
  {
    id: 3,
    step: "03",
    title: "Progettazione",
    description: "Sviluppiamo soluzioni personalizzate con materiali certificati e tecnologie avanzate."
  },
  {
    id: 4,
    step: "04",
    title: "Realizzazione",
    description: "Eseguiamo i lavori con personale qualificato, rispettando i tempi e gli standard di sicurezza."
  },
  {
    id: 5,
    step: "05",
    title: "Controllo Qualità",
    description: "Verifichiamo che ogni intervento rispetti i più alti standard qualitativi e normativi."
  },
  {
    id: 6,
    step: "06",
    title: "Assistenza",
    description: "Forniamo supporto post-intervento e servizi di manutenzione per garantire la durata nel tempo."
  }
];

export const clients = [
  { name: "Arcese", logo: null },
  { name: "DHL", logo: null },
  { name: "Geodis", logo: null },
  { name: "Kuehne + Nagel", logo: null },
  { name: "Esselunga", logo: null },
  { name: "IN'S", logo: null },
  { name: "MD", logo: null },
  { name: "AIA", logo: null },
  { name: "Penny Market", logo: null },
  { name: "CBRE", logo: null },
  { name: "Klepierre", logo: null },
  { name: "Savills", logo: null },
  { name: "Combi Connect", logo: null },
  { name: "Malpensa Intermodale", logo: null },
  { name: "Colussi S.p.A.", logo: null },
  { name: "Università Bocconi", logo: null },
  { name: "IULM", logo: null }
];

export const gallery = [
  {
    id: 1,
    title: "",
    category: "",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/o8c50on7_12a6ae32-cd1f-4c9d-81f8-70491e5f19f7.jpg"
  },
  {
    id: 2,
    title: "",
    category: "",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/6bq14t1y_f4ecfe40-796f-4c83-a646-d5d743408061.jpg"
  },
  {
    id: 3,
    title: "",
    category: "",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/efwg2q0c_59b68a11-e4c2-4222-8aa2-0c9b2319c5ae.jpg"
  },
  {
    id: 4,
    title: "",
    category: "",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/127wzrtk_17feb343-cc18-4092-bf0b-f0e3cd42b3de.jpg"
  },
  {
    id: 5,
    title: "",
    category: "",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/mfdpztjt_eefcb5a0-6067-4753-8858-3eb7e4ac18d4.jpg"
  },
  {
    id: 6,
    title: "",
    category: "",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/h6ycxqp4_Immagine%20WhatsApp%202025-11-05%20ore%2008.07.11_4429ad62.jpg"
  }
];

export const products = [
  {
    id: 1,
    name: "Pensilina per Carrelli",
    category: "Strutture Protettive",
    description: "Pensilina moderna per riparo carrelli della spesa, realizzata con materiali resistenti alle intemperie e design funzionale.",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/ko3gdfe4_IMG_8254.JPG"
  },
  {
    id: 2,
    name: "Barriere di Sicurezza Industriali",
    category: "Sicurezza Industriale",
    description: "Barriere di protezione robuste in acciaio verniciato giallo, ideali per la delimitazione di aree pericolose in magazzini e stabilimenti.",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/yea5nrwr_96419f7d-1e3c-4827-8d02-f6f5d1aa4754.jpg"
  },
  {
    id: 3,
    name: "Parapetti di Protezione",
    category: "Sicurezza Industriale",
    description: "Sistemi di parapetti modulari per la protezione di aree ad alto rischio, conformi alle normative di sicurezza vigenti.",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/o6ohr8jm_ab94ce13-fb1c-4263-b245-f31e35c048c7.jpg"
  },
  {
    id: 4,
    name: "Portali e Strutture Metalliche",
    category: "Installazione Strutture",
    description: "Progettazione e installazione di portali in acciaio su misura per applicazioni industriali e commerciali.",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/tlh5azvh_Immagine%20WhatsApp%202024-10-24%20ore%2014.26.15_a495179b.jpg"
  },
  {
    id: 5,
    name: "Strutture di Accesso",
    category: "Installazione Strutture",
    description: "Strutture metalliche di accesso sicure per edifici commerciali e industriali.",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/zx4u46fb_dfd1a2d7-af88-4573-8109-3a7817d05200.jpg"
  },
  {
    id: 6,
    name: "Occhi di Gatto Stradali",
    category: "Segnaletica Stradale",
    description: "Dispositivi catarifrangenti ad alta visibilità per delimitazione e guida sicura su strade e parcheggi.",
    image: "https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/sdw3fugh_jnp%20occhi%20di%20gatto"
  }
];

export const aboutUs = {
  history: "SI.SA. LINE S.r.l., un'azienda che opera con successo nel settore della segnaletica stradale da anni. Mantenendo l'esperienza, l'affidabilità e la qualità che ci contraddistinguono.",
  mission: "Offrire soluzioni di segnaletica che coniugano qualità, sicurezza e valore nel tempo. Ci impegniamo a fornire un servizio completo che va dalla consulenza tecnica alla manutenzione, utilizzando materiali certificati e tecnologie avanzate.",
  vision: "Consolidare la nostra presenza come partner affidabile per aziende, enti e operatori che cercano un interlocutore competente, puntuale e capace di gestire progetti complessi.",
  values: [
    {
      title: "Esperienza",
      description: "Una presenza consolidata nel settore della segnaletica stradale e generale."
    },
    {
      title: "Affidabilità",
      description: "Rispettiamo gli impegni presi con i nostri clienti, garantendo puntualità e professionalità."
    },
    {
      title: "Qualità",
      description: "Utilizziamo solo materiali certificati e tecnologie all'avanguardia per garantire risultati eccellenti."
    },
    {
      title: "Sicurezza",
      description: "La sicurezza è al centro delle nostre operazioni, con personale formato e procedure rigorose."
    },
    {
      title: "Sostenibilità",
      description: "Rispettiamo l'ambiente attraverso lo smaltimento responsabile dei materiali."
    }
  ]
};

// Form submission handler (mock)
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Messaggio inviato con successo!" });
    }, 1000);
  });
};
